export default __webpack_public_path__ + "media/images/portfolio/gallery-04-480x580-0365b4f5551156251af0fd1e7554fc87.jpg";